import { render, staticRenderFns } from "./FeedbackInitiateModal.vue?vue&type=template&id=44a98e6d&"
import script from "./FeedbackInitiateModal.vue?vue&type=script&lang=js&"
export * from "./FeedbackInitiateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports